<template>
    <nav id="sidebar" class="bg-white " v-if="isBig">

        <div class="d-flex flex-column flex-shrink-0 sidebar-height ">
            <a href="#" class="d-flex align-items-center pb-3 mb-md-0  link-dark text-decoration-none border-bottom ps-3 pt-2 ">
                <img src="/favicon.png" style="height: 2rem;" class="">
                <span class="d-none d-lg-block d-xl-block "> Commercial Management</span>
            </a>
            <ul class="nav nav-pills flex-column mb-auto border-end " style="height:100%" v-if="cookiesData">
                <h6 class="dropdown-header text-capitalize">Main</h6>
                <NavLink
                icon="fa-solid fa-building"
                navName="Projects"
                :selected="activeLink"
                :linkId="LinkList.MAIN_DASHBOARD"
                @click="OnNavLinkClick(dotNetUrl + '/project/list')"
                :isRoute="false"
                />
                <NavLink
                data-bs-toggle="collapse" href="#CompanySubMenu"
                icon="fa-solid fa-user-tie"
                navName="Organisation"
                :selected="activeLink"
                :linkId="LinkList.MAIN_COMPANY"
                />
                <div class="collapse ps-3" id="CompanySubMenu">
                    <NavLink
                    navName="User Directory"
                    :selected="activeLink"
                    :linkId="LinkList.MAIN_COMPANY"
                    @click="OnNavLinkClick(directoryUrl + '/directory/user')"
                    />
                    <NavLink
                    navName="Office Directory"
                    :selected="activeLink"
                    :linkId="LinkList.MAIN_COMPANY"
                    @click="OnNavLinkClick(directoryUrl + '/directory/office')"
                    />
                    <NavLink
                    navName="Region Directory"
                    :selected="activeLink"
                    :linkId="LinkList.MAIN_COMPANY"
                    @click="OnNavLinkClick(directoryUrl + '/directory/region')"
                    />
                    <NavLink
                    navName="Company Directory"
                    :selected="activeLink"
                    :linkId="LinkList.MAIN_COMPANY"
                    @click="OnNavLinkClick(directoryUrl + '/directory/company')"
                    />
                </div>
                <NavLink
                icon="fa-solid fa-file-invoice-dollar"
                navName="Cost Codes"
                :selected="activeLink"
                :linkId="LinkList.COST_CODES"
                @click="OnNavLinkClick(directoryUrl + '/directory/costcode')"
                />
                <template v-if="projectInfo._id">
                    <h6 class="dropdown-header text-capitalize">Project</h6>
                    <NavLink
                    :isSub="true"
                    icon="fa-solid fa-chart-column"
                    navName="Project Info"
                    :selected="activeLink"
                    :linkId="LinkList.SUMMARY"
                    @click="OnNavLinkClick('/project/' + projectInfo._id,true)"
                    />
                    <NavLink
                    :isSub="true"
                    icon="fa-solid fa-list"
                    navName="Details"
                    :selected="activeLink"
                    :linkId="LinkList.PROJECT_DETAILS"
                    @click="OnNavLinkClick(dotNetUrl + '/project/view?id='+projectInfo.projectOldId)"
                    :isRoute="false"
                    />
                    <NavLink
                    v-if="permission.indexOf(ModuleActionList.DIRECTORY_VIEW) > -1"
                    :isSub="true"
                    icon="fa-solid fa-book-bookmark"
                    navName="Directory"
                    :selected="activeLink"
                    :linkId="LinkList.PROJECT_DIRECTORY"
                    @click="OnNavLinkClick('/project/' + projectInfo._id + '/directory',true)"
                    />
                    <!-- <NavLink
                    v-if="permission.indexOf(ModuleActionList.PROCESS_VIEW) > -1"
                    :isSub="true"
                    icon="fa-solid fa-sitemap"
                    navName="Process List"
                    :selected="activeLink"
                    :linkId="LinkList.PROJECT_PROCESS"
                    @click="OnNavLinkClick('/project/' + projectInfo._id + '/process',true)"
                    /> -->
                    <!-- <NavLink
                    :isSub="true"
                    icon="fa-solid fa-file-circle-check"
                    navName="Approval List"
                    :selected="activeLink"
                    :linkId="LinkList.APPROVAL_LIST"
                    @click="OnNavLinkClick('/project/' + projectInfo._id+ '/approvals',true)"
                    /> -->
                    <NavLink
                    v-if="permission.indexOf(ModuleActionList.ITEM_MASTER_LIST_VIEW) > -1"
                    :isSub="true"
                    icon="fa-solid fa-list-check"
                    navName="Item Master List"
                    :selected="activeLink"
                    :linkId="LinkList.BOQ_MASTER_LIST"
                    @click="OnNavLinkClick(boqUrl +'/boq/' + projectInfo._id + '/master')"
                    />
                    <NavLink
                    v-if="permission.indexOf(ModuleActionList.BOQ_VIEW) > -1"
                    :isSub="true"
                    icon="fa-solid fa-file-signature"
                    navName="Bill Of Quantities"
                    :selected="activeLink"
                    :linkId="LinkList.BILL_OF_QUANTITIES"
                    @click="OnNavLinkClick(boqUrl +'/boq/' + projectInfo._id)"
                    />
                    <NavLink
                    v-if="permission.indexOf(ModuleActionList.CONSOLIDATED_LIST_VIEW) > -1"
                    :isSub="true"
                    icon="fa-solid fa-copy" 
                    navName="Consolidated List"
                    :selected="activeLink"
                    :linkId="LinkList.CONSOLIDATED_LIST_VIEW"
                    @click="OnNavLinkClick(boqUrl +'/boq/' + projectInfo._id + '/consolidated')"
                    />
                    <!-- <NavLink
                    v-if="permission.indexOf(ModuleActionList.RATE_VIEW) > -1"
                    :isSub="true"
                    icon="fa-solid fa-comment-dollar" 
                    navName="Rate List"
                    :selected="activeLink"
                    :linkId="LinkList.BOQ_RATE_LIST"
                    @click="OnNavLinkClick(boqUrl +'/boq/' + projectInfo._id + '/rates')"
                    /> -->
                    <NavLink
                    v-if="permission.indexOf(ModuleActionList.BOQ_QUOTATION_VIEW) > -1"
                    :isSub="true"
                    icon="fa-solid fa-file-lines" 
                    navName="Quotation"
                    :selected="activeLink"
                    :linkId="LinkList.QUOTATIONS_LIST"
                    @click="OnNavLinkClick(boqUrl +'/boq/' + projectInfo._id + '/quotation/list')"
                    />
                    <NavLink
                    icon="fa-solid fa-cubes" 
                    navName="Trade Packages"
                    :selected="activeLink"
                    :linkId="LinkList.TRADE_PACKAGE_LIST"
                    @click="OnNavLinkClick(dotNetUrl + '/tradepackage/'+projectInfo.projectOldId)"
                    />
                    <NavLink
                    icon="fa-solid fa-hand-holding-dollar" 
                    navName="Client Progress Claim"
                    :selected="activeLink"
                    @click="OnNavLinkClick(dotNetUrl + '/progressclaim/'+projectInfo.projectOldId)"
                    />
                    <!-- <h6 class="dropdown-header text-capitalize">Documents</h6>
                    <NavLink
                    icon="fa-solid fa-file-contract"
                    navName="Documents"
                    :selected="activeLink"
                    :linkId="LinkList.DOCUMENTS"
                    /> -->
                </template>
            </ul>
            <div class="sidebar-footer border-end" v-if="cookiesData">
                <hr />
                <div class="d-flex justify-content-between pt-0 p-3" >
                    <div class="dropdown">
                        <a href="#" class="d-flex align-items-center link-dark text-decoration-none dropdown-toggle text-capitalize" id="dropdownUser2" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="fa-solid fa-user pe-2"></i>
                            <strong>{{userInfo?.firstName || 'User'}}</strong>
                        </a>
                        <ul class="dropdown-menu text-small shadow" aria-labelledby="dropdownUser2">
                            <h6 class="dropdown-header text-capitalize">{{userInfo?.fullname || 'User'}}</h6>
                            <li><a class="dropdown-item" href="#">Settings</a></li>
                            <li><hr class="dropdown-divider"></li>
                            <li @click="LogoutUser"><a class="dropdown-item" href="#">Sign out</a></li>
                        </ul>
                    </div>
                    <div class="tooltip-custom" @click="changeView">
                        <span role="button" class="ms-3"><i class="fa-solid fa-angles-left fa-xl"></i></span>
                        <span class="tooltiptext-custom">Minimize</span>
                    </div>
                </div>
            </div>
        </div>
    </nav>

    <nav id="sidebar-mini" class="bg-white shadow-sm" v-else>
        <div class="d-flex flex-column flex-shrink-0 sidebar-height" >
            <a href="#" class="d-flex align-items-center pb-2 mb-md-0  link-dark text-decoration-none p-3 pb-0 border-bottom">
                <img src="/lens.svg" style="height: 2rem;" class="">
                <span class="d-none d-lg-block d-xl-block "></span>
            </a>
            <ul class="nav nav-pills nav-flush flex-column mb-auto text-center" v-if="cookiesData" >
                <NavLinkIcon
                icon="fa-solid fa-building"
                :navName="$t('Projects')"
                :selected="activeLink"
                :linkId="LinkList.MAIN_DASHBOARD"
                :link="dotNetUrl + '/project/list'"
                :isRoute="false"
                />
                <div class="dropend">
                    <NavLinkIcon
                    data-bs-toggle="dropdown"
                    icon="fa-solid fa-user-tie" 
                    :navName="$t('Organisation')"
                    :selected="activeLink"
                    :linkId="LinkList.MAIN_COMPANY"
                    />
                    <ul class="dropdown-menu text-small shadow" offset="5px">
                        <li><a class="dropdown-item" :href="directoryUrl + '/directory/user'"> {{ $t('User') }}</a></li>
                        <li><a class="dropdown-item" :href="directoryUrl + '/directory/office'"> {{ $t('Office') }}</a></li>
                        <li><a class="dropdown-item" :href="directoryUrl + '/directory/region'"> {{ $t('Region') }}</a></li>
                        <li><a class="dropdown-item" :href="directoryUrl + '/directory/company'">  {{ $t('Company List') }}</a></li>
                    </ul>
                </div>
                <NavLinkIcon
                icon="fa-solid fa-file-invoice-dollar"
                :navName="$t('Cost Code')"
                :selected="activeLink"
                :linkId="LinkList.COST_CODES"
                @click="OnNavLinkClick(directoryUrl + '/directory/costcode')"
                />
                <NavLinkIcon
                data-bs-toggle="dropdown"
                icon="fa-solid fa-laptop-file"
                :navName="$t('Bidding')"
                :selected="activeLink"
                :linkId="LinkList.HIGH_LEVEL_ESTIMATES"
                :link="boqUrl + '/high-level-estimates'"
                @click="OnNavLinkClick(boqUrl + '/high-level-estimates')"
                />
                <div class="dropend">
                    <NavLinkIcon
                    data-bs-toggle="dropdown"
                    icon="fa-solid fa-wrench" 
                    :navName="$t('Administrative Page')"
                    :selected="activeLink"
                    />
                    <ul class="dropdown-menu text-small shadow" offset="5px">
                        <li><a class="dropdown-item" :href="dotNetUrl +'/admin/taxrules'"> {{ $t('Tax Rules') }}</a></li>
                        <li><a class="dropdown-item" :href="dotNetUrl +'/admin/bankinformation'"> {{ $t('Bank Details') }}</a></li>
                        <li><a class="dropdown-item" :href="dotNetUrl +'/admin/currency/rates'"> {{ $t('Exchange Rates') }}</a></li>
                        <li><a class="dropdown-item" :href="dotNetUrl +'/admin/signatures'"> {{ $t('Authorized Signatures') }}</a></li>
                    </ul>
                </div>
                <template  v-if="projectInfo._id">
                    <NavLinkIcon
                    class="border-top"
                    icon="fa-solid fa-chart-column"
                    :navName="$t('Project Info')"
                    :selected="activeLink"
                    :linkId="LinkList.SUMMARY"
                    :link="'/project/' + projectInfo._id"
                    :isRoute="true"
                    />
                    <NavLinkIcon
                    icon="fa-solid fa-chalkboard-user"
                    :navName="$t('Project Overview')"
                    :selected="activeLink"
                    :link="dotNetUrl + '/project/overview/'+projectInfo.projectOldId"
                    :isRoute="false"
                    />
                    <NavLinkIcon
                    icon="fa-solid fa-list"
                    :navName="$t('Project Details')"
                    :selected="activeLink"
                    :link="dotNetUrl + '/project/view?id=' + projectInfo.projectOldId"
                    :isRoute="false"
                    />
                    <NavLinkIcon
                    v-if="permission.indexOf(ModuleActionList.DIRECTORY_VIEW) > -1"
                    icon="fa-solid fa-book-bookmark"
                    :navName="$t('Directory')"
                    :selected="activeLink"
                    :linkId="LinkList.PROJECT_DIRECTORY"
                    :link="'/project/' + projectInfo._id+ '/directory'"
                    :isRoute="true"
                    />
                    <!-- <NavLinkIcon
                    v-if="permission.indexOf(ModuleActionList.PROCESS_VIEW) > -1"
                    icon="fa-solid fa-sitemap"
                    navName="Process List"
                    :selected="activeLink"
                    :linkId="LinkList.PROJECT_PROCESS"
                    :link="'/project/' + projectInfo._id+ '/process'"
                    :isRoute="true"
                    />
                    <NavLinkIcon
                    icon="fa-solid fa-file-circle-check"
                    navName="Approval List"
                    :selected="activeLink"
                    :linkId="LinkList.APPROVAL_LIST"
                    :link="'/project/' + projectInfo._id+ '/approvals'"
                    :isRoute="true"
                    /> -->
                    <NavLinkIcon
                    v-if="permission.indexOf(ModuleActionList.ITEM_MASTER_LIST_VIEW) > -1"
                    icon="fa-solid fa-list-check" 
                    :navName="$t('Item Master List')"
                    :selected="activeLink"
                    :linkId="LinkList.BOQ_MASTER_LIST"
                    @click="OnNavLinkClick(boqUrl +'/boq/' + projectInfo._id + '/master')"
                    :link="boqUrl +'/boq/' + projectInfo._id + '/master'"
                    :isRoute="false"
                    />
                    <NavLinkIcon
                    v-if="permission.indexOf(ModuleActionList.BOQ_VIEW) > -1"
                    icon="fa-solid fa-file-signature"
                    :navName="$t('Bill of Quantities')"
                    :selected="activeLink"
                    :linkId="LinkList.BILL_OF_QUANTITIES"
                    :link="boqUrl +'/boq/' + projectInfo._id"
                    :isRoute="false"
                    />
                    <NavLinkIcon
                    v-if="permission.indexOf(ModuleActionList.CONSOLIDATED_LIST_VIEW) > -1"
                    icon="fa-solid fa-copy" 
                    :navName="$t('Consolidated List')"
                    :selected="activeLink"
                    :linkId="LinkList.CONSOLIDATED_LIST_VIEW"
                    :link="boqUrl +'/boq/' + projectInfo._id + '/consolidated'"
                    :isRoute="false"
                    />
                    <!-- <NavLinkIcon
                    v-if="permission.indexOf(ModuleActionList.RATE_VIEW) > -1"
                    icon="fa-solid fa-comment-dollar" 
                    navName="Rate List"
                    :selected="activeLink"
                    :linkId="LinkList.BOQ_RATE_LIST"
                    :link="boqUrl +'/boq/' + projectInfo._id + '/rates'"
                    :isRoute="false"
                    /> -->
                    <NavLinkIcon
                    v-if="permission.indexOf(ModuleActionList.BOQ_QUOTATION_VIEW) > -1"
                    icon="fa-solid fa-file-lines" 
                    :navName="$t('Quotation')"
                    :selected="activeLink"
                    :linkId="LinkList.QUOTATIONS_LIST"
                    :link="boqUrl +'/boq/' + projectInfo._id + '/quotation/list'"
                    :isRoute="false"
                    />
                    <NavLinkIcon
                    icon="fa-solid fa-cubes" 
                    :navName="$t('Trade Packages')"
                    :selected="activeLink"
                    :linkId="LinkList.TRADE_PACKAGE_LIST"
                    :link="dotNetUrl + '/tradepackage/'+projectInfo.projectOldId"
                    :isRoute="false"
                    />
                    <NavLinkIcon
                    icon="fa-solid fa-money-check-dollar" 
                    :navName="$t('Purchase Order')"
                    :selected="activeLink"
                    :link="dotNetUrl + '/PurchaseOrder/purchaseordersList?projectId='+projectInfo.projectOldId"
                    :isRoute="false"
                    />
                    <NavLinkIcon
                    icon="fa-solid fa-hand-holding-dollar" 
                    :navName="$t('Client Progress Claim')"
                    :selected="activeLink"
                    :link="dotNetUrl + '/progressclaim/'+projectInfo.projectOldId"
                    :isRoute="false"
                    />
                    <NavLinkIcon
                    icon="fa-solid fa-arrow-right-arrow-left" 
                    :navName="$t('Change Request')"
                    :selected="activeLink"
                    :link="dotNetUrl + '/change-requestV2/'+projectInfo.projectOldId"
                    :isRoute="false"
                    />
                    <!--<NavLinkIcon
                    icon="fa-solid fa-arrow-right-arrow-left" 
                    :navName="$t('Change Order')"
                    :selected="activeLink"
                    :link="dotNetUrl + '/change-request/'+projectInfo.projectOldId"
                    :isRoute="false"
                    />-->
                    <NavLinkIcon
                    icon="fa-solid fa-receipt" 
                    :navName="$t('Client Invoice')"
                    :selected="activeLink"
                    :link="dotNetUrl + '/clientinvoice/'+projectInfo.projectOldId"
                    :isRoute="false"
                    />
                    <NavLinkIcon
                    icon="fas fa-sync" 
                    :navName="$t('Contingency')"
                    :selected="activeLink"
                    :link="dotNetUrl + '/contingencyv2/summary/'+projectInfo.projectOldId"
                    :isRoute="false"
                    />
                    <!--<NavLinkIcon
                    icon="fas fa-sync" 
                    :navName="$t('Contingency')"
                    :selected="activeLink"
                    :link="dotNetUrl + '/contingencyv2/summary/'+projectInfo.projectOldId"
                    :link="dotNetUrl + '/contingency/'+projectInfo.projectOldId"
                    :isRoute="false"
                    />
                    />-->
                    <NavLinkIcon
                    icon="fa-solid fa-helmet-safety" 
                    :navName="$t('Vendor List')"
                    :selected="activeLink"
                    :link="dotNetUrl + '/project/vendor-list/'+projectInfo.projectOldId"
                    :isRoute="false"
                    />
                    <!-- <NavLinkIcon
                    icon="fa-solid fa-user-lock" 
                    navName="Contact Password Manager"
                    :selected="activeLink"
                    :link="dotNetUrl + '/mmoserstaff/ContractManager/'+projectInfo.projectOldId"
                    :isRoute="false"
                    /> -->
                    <!-- <NavLinkIcon
                    v-if="permission.indexOf(ModuleActionList.TRADE_PACKAGE_VIEW) > -1"
                    icon="fa-solid fa-cubes" 
                    navName="Trade Packages"
                    :selected="activeLink"
                    :linkId="LinkList.TRADE_PACKAGE_LIST"
                    @click="OnNavLinkClick(boqUrl +'/boq/' + projectInfo._id + '/packages')"
                    /> -->
                </template>
                <!-- <NavLinkIcon
                icon="fa-solid fa-file-contract"
                navName="Documents"
                :selected="activeLink"
                :linkId="LinkList.DOCUMENTS"
                /> -->
            </ul>
            <div class="dropend border-top" v-if="cookiesData">
                <a href="#" class="d-flex align-items-center justify-content-center p-3 link-dark text-decoration-none dropdown-toggle text-capitalize" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fa-solid fa-user"></i>
                </a>
                <ul class="dropdown-menu text-small shadow" >
                    <h6 class="dropdown-header text-capitalize">{{userInfo?.fullname || 'User'}}</h6>
                    <li><a class="dropdown-item" href="#">{{$t('Settings')}}</a></li>
                    <li><hr class="dropdown-divider"></li>
                    <li @click="LogoutUser"><a class="dropdown-item" href="#">{{ $t('Sign Out') }}</a></li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
import { GetMyUserInfo,LogOut } from '@/actions/userActions.js'
import NavLink from '@/components/layout/NavLink.vue'
import NavLinkIcon from '@/components/layout/NavLinkIcon.vue'
import { LinkList,ModuleActionList } from '@/helpers/utilities.js'
import { useCookies } from "vue3-cookies"
import  { mapGetters } from 'vuex'
import 'dotenv/config'
export default {
    name : "SideBar",
    components : {
        NavLink,
        NavLinkIcon
    },
    data(){
        return {
            userInfo : {},
            isBig : false,
            directoryUrl : process.env.VUE_APP_DIRECTORY_URL,
            boqUrl : process.env.VUE_APP_BOQ_URL,
            dotNetUrl : process.env.VUE_APP_DOTNET_URL,
            ModuleActionList : ModuleActionList,
            cookiesData : null
        }
    },
    mounted : function(){
        const self = this
        self.GetMyInfo()
        
    },
    methods : {
        changeView(){
            this.isBig = !this.isBig
        },
        GetMyInfo (){
            const self = this
            GetMyUserInfo().then((res)=>{
                if(res==401){
                    self.cookiesData = null
                }else{
                    self.userInfo = res
                    self.cookiesData = 'checker'
                }
            })
        },
        LogoutUser (){
            const { cookies } = useCookies()
            const self = this
            LogOut().then(()=>{
                cookies.remove('_auzer')
                self.cookiesData = null
                self.$router.push({name : 'SignOut', query: {signout : 'yes'}})
            })
        },
        isActive(linkId, classList){
            if(this.activeLink==linkId)
                return classList + ' active'
            else
                return classList
        },
        OnNavLinkClick(url, isRouterLink = false){
            if(isRouterLink){
                this.$router.push(url)
            }else{
                window.location.href = url
            }
        }
    },
    computed : {
        ...mapGetters(['activeLink','projectInfo','permission']),
        LinkList : ()=>LinkList
    }
}
</script>
